import { useT } from '@/i18n/runtime';

/**
 * The platform credit (owner round 2026-08-28 item 4): ONE small, muted,
 * consistent line at the very foot of every customer screen — the KYC Hub
 * mark + "Powered by KYC Hub". The tenant's brand owns the journey (big);
 * the platform signs it quietly (small). It renders regardless of tenant —
 * it IS the platform credit, not tenant chrome — and deliberately links
 * nowhere: nothing at the foot of a regulated journey may navigate the
 * customer away from their session.
 *
 * The mark is the KYC Hub monogram (brand/kychub-logo.svg, geometry copied
 * verbatim). The source asset is authored white-on-transparent, so it is
 * inlined with `fill="currentColor"`: inheriting the muted foreground token
 * is what keeps it visible in BOTH themes instead of invisible on light.
 *
 * Mounted by the SHELLS (FlowShell, SessionLanding, the App-level terminal
 * screens), never per-step — the SupportAffordance lesson: a new screen must
 * not be able to ship without it.
 */
export function PoweredByKycHub(): JSX.Element {
  const { t } = useT();
  return (
    <footer className="powered-by" data-powered-by="kychub">
      <svg
        className="powered-by-mark"
        role="img"
        aria-label="KYC Hub"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4.80769 15.5769V11.7308L11.5385 4.42308H15.3846L4.80769 15.5769Z" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM13.5342 17.6904C12.4587 18.1854 11.2616 18.4615 10 18.4615C5.32682 18.4615 1.53846 14.6732 1.53846 10C1.53846 7.28385 2.81824 4.8666 4.80769 3.31837V10.3846L7.5 7.5V2.11538L7.40243 1.94464C8.2209 1.68091 9.09382 1.53846 10 1.53846C14.6732 1.53846 18.4615 5.32682 18.4615 10C18.4615 12.4253 17.4412 14.6122 15.8064 16.155L10.5769 10.5769L8.84615 12.5L13.5342 17.6904Z"
          fill="currentColor"
        />
      </svg>
      <span>{t('droom.poweredBy')}</span>
    </footer>
  );
}
